import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateCompanyTransactionRequestSchema,
  TCreateCompanyTransactionResponseSchema,
} from "./createCompanyTransaction.schema";

export const createCompanyTransaction =
  (axios: IAxiosInstance) =>
  async (body: TCreateCompanyTransactionRequestSchema) => {
    const { companyID, ...rest } = body;

    const response = await axios.noRetry.post<
      IApiResponse<TCreateCompanyTransactionResponseSchema>
    >(`/companies/${companyID}/transactions`, rest);

    return response.data;
  };
